import { render, staticRenderFns } from "./VueSelect.vue?vue&type=template&id=700ec20e&scoped=true&"
import script from "./VueSelect.vue?vue&type=script&lang=js&"
export * from "./VueSelect.vue?vue&type=script&lang=js&"
import style0 from "./VueSelect.vue?vue&type=style&index=0&id=700ec20e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700ec20e",
  null
  
)

export default component.exports